import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import CvaService from '../services/CvaService';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dropdown } from 'primereact/dropdown';
import InstitutionService from '../services/InstitutionService';

const Chauffeur = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Table {...{setForm, setYesNo}} />
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setForm, setYesNo} = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        CvaService.get((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            }
        );
    }

    const openNew = () => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: null,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        });
    }

    const editItem = (item) => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: item,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        })
    }

    const deleteItem = (item) => {
        setYesNo({   
            visible: true,
            message : "Confirmez-vous la suppression ?",
            hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
            callback : ()=> {
                setLoading(true);
                CvaService.delete(item.id, (data, status)=>{
                    setLoading(false);
                    loadItems();
                });
            },
        });
    }
    
    return (
        <>
            <h5>Liste des chauffeurs</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" 
                                onClick={openNew}/>
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={20} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}  */
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">
                 
                <Column field="id" header="Identifiant" hidden sortable  />
                <Column field="matricule" header="Matricule" sortable  />
                <Column header="Nom" sortable style={{fontWeight: 'bold'}} body={(item)=> item.nom + " " + item.prenom}/>
                <Column field="telephone" header="Téléphone" sortable /> 
                <Column field="numeroPermis" header="Numéro permis" sortable />
                <Column field="institution.libelle" header="Institution" sortable />
                <Column field="etatChauffeur" header="Etat chauffeur" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.etatChauffeur === 'EN_SERVICE'? 'qualified' : 'unqualified'}`}>
                        {item.etatChauffeur}
                    </span>
                } />
                
                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editItem(selectedItem)}/>
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" onClick={()=> deleteItem(selectedItem)}/>
                    </div>
                } />
            </DataTable>
        </>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);

    const [institutions, setInstitutions] = useState([]);

    useEffect(()=> {
        if(!visible) return;
        InstitutionService.get((data)=> data && setInstitutions(data), {size: pageMaxSize})
    }, [visible])
    
    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, [e.target.id]: value});
        }
        else if(e.checked !== undefined) {
            setData({...data, [e.target.id]: e.target.checked});
        }else{
            alert("Binding fails.")
        }
    }
    
    const submit = () => {
        setYesNo(
            {   
                visible: true,
                message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(data.id) CvaService.update(data, onResponse); else CvaService.add(data, onResponse);
                },
            }
        )
    
    }

    return(
        <Dialog visible={visible} style={{ width: '800px' }} header="Détails du Cva" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Valider" icon="pi pi-check" className="p-button-text" onClick={submit} loading={loading} />
                </>
            } 
            onHide={hide}
            >  
                <div className="field" hidden>
                    <label htmlFor="matricule">Matricule</label>
                    <InputText id="matricule" value={data && data.matricule} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="matricule">Matricule</label>
                    <InputText id="matricule" value={data && data.matricule} 
                        onChange={bind} required placeholder='ex: AZ125' autoFocus/>
                </div>
                <div className="field">
                    <label htmlFor="nom">Nom</label>
                    <InputText id="nom" value={data && data.nom} onChange={bind} required placeholder='ex: AGOSSOU' />
                </div>
                <div className="field">
                    <label htmlFor="prenom">Pénoms</label>
                    <InputText id="prenom" value={data && data.prenom} onChange={bind} required placeholder='ex: Zinsou' />
                </div>
                <div className="field">
                    <label htmlFor="telephone">Téléphone</label>
                    <InputText id="telephone" value={data && data.telephone} 
                        onChange={bind} placeholder='ex: +229 98 00 00 00'  keyfilter="num"/>
                </div>
                <div className="field">
                    <label htmlFor="numeroPermis">Numéro permis</label>
                    <InputText id="numeroPermis" value={data && data.numeroPermis} 
                        onChange={bind} placeholder='' />
                </div>
                <div className="field">
                    <label htmlFor="institution">Institution</label>
                    <Dropdown id="institution" options={institutions} value={data?.institution} onChange={bind}
                        optionLabel="libelle" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="etatChauffeur">Etat Chauffeur</label>
                    <Dropdown id="etatChauffeur" onChange={bind} placeholder="Aucune sélection"
                        options={["EN_SERVICE", "EN_CONGE"]} 
                        value={data?.etatChauffeur} />
                </div>
            </Dialog>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default Chauffeur;